import React from "react";

export default function Loader({ text = "Loading..." }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center w-full">
      <div className="w-12 h-12 border-4 border-[#F4C430] border-t-transparent rounded-full animate-spin mb-4"></div>
      <p className="text-gray-500 font-medium animate-pulse">{text}</p>
    </div>
  );
}